// userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: null,
  isEdit: false,
  isView: false,
  isDelete: false,
  isShare: false,
  table: false,
  isTemplate: false,
  isBlankPlan: false,
  isTemplateToPlan: false
};

const planSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {
    setPlanForEdit: (state, action) => {
      state.id = action.payload.id;
      state.isEdit = action.payload.isEdit;
      state.table = action.payload.table;
      state.isBlankPlan = action.payload.isBlankPlan;
      state.isTemplateToPlan = action.payload.isTemplateToPlan;
    },
    setPlanForView: (state, action) => {
      state.id = action.payload.id;
      state.isView = action.payload.isView;
      state.table = action.payload.table;
    },
    setPlanForDelete: (state, action) => {
      state.id = action.payload.id;
      state.isDelete = action.payload.isDelete;
      state.table = action.payload.table;
      state.isBlankPlan = action.payload.isBlankPlan;
      state.isTemplateToPlan = action.payload.isTemplateToPlan;
    },
    setPlanForShare: (state, action) => {
      state.id = action.payload.id;
      state.isShare = action.payload.isShare;
      state.table = action.payload.table;
    },
    setTemplateForCreate: (state, action) => {
      state.id = action.payload.id;
      state.isTemplate = action.payload.isTemplate;
      state.isBlankPlan = action.payload.isBlankPlan;
      state.isTemplateToPlan = action.payload.isTemplateToPlan;
      state.table = action.payload.table;
    },
    
    setTemplateForEdit: (state, action) => {
      state.id = action.payload.id;
      state.isEdit = action.payload.isEdit;
      state.isTemplate = action.payload.isTemplate;
      state.isBlankPlan = action.payload.isBlankPlan;
      state.isTemplateToPlan = action.payload.isTemplateToPlan;
      state.table = action.payload.table;
    },
    resetPlanState: (state) => {
      state.id = null;
      state.isEdit = false;
      state.isView = false;
      state.isDelete = false;
      state.isShare = false;
      state.table = false;
      state.isTemplate = false;
      state.isBlankPlan = false;
      state.isTemplateToPlan = false;
    },
  },
});

export const {
  setPlanForEdit,
  setPlanForDelete,
  setPlanForView,
  setPlanForShare,
  setTemplateForCreate,
  resetPlanState,
  setTemplateForEdit,
} = planSlice.actions;
export default planSlice.reducer;
